// frontend/src/components/projects/PersonalizedProjectGenerator.tsx

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { projectService, ProjectApiError } from '../../services/project.service';

export function PersonalizedProjectGenerator() {
  const navigate = useNavigate();
  const [interest, setInterest] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleGenerate() {
    if (!interest.trim()) return;
    setIsLoading(true);
    setError(null);
    try {
      const project = await projectService.generatePersonalizedProject(interest.trim());
      navigate(`/projects/${project.id}`);
    } catch (err) {
      setError(err instanceof ProjectApiError ? err.message : 'Proje üretilemedi.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="card admin-ai-recommendation-card" style={{ marginBottom: 24 }}>
      <h3 className="parent-section-title">✨ AI ile İstediğin Derste Bana Özel Proje Üret</h3>
      <p className="parent-empty-text" style={{ marginBottom: 12 }}>
        İstediğin dersi veya ilgi alanını yaz; Gemini senin için interaktif bir proje fikri ve başlangıç materyali hazırlasın.
      </p>
      <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
        <input
          type="text"
          className="input"
          placeholder="Örn: Matematik Geometri, Fen Güneş Sistemi, İngilizce Kelimeler, Python Oyun..."
          value={interest}
          onChange={(e) => setInterest(e.target.value)}
          style={{ flex: 1 }}
        />
        <button type="button" className="lesson-btn primary" onClick={handleGenerate} disabled={isLoading || !interest.trim()}>
          {isLoading ? '⏳ Hazırlanıyor...' : '🚀 Proje Üret'}
        </button>
      </div>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {['📐 Matematik Geometri', '🧪 Fen Güneş Sistemi', '🐍 Python Oyun', '🇬🇧 İngilizce Flashcard', '📚 Türkçe Kelime Analizi'].map((tag) => (
          <button
            key={tag}
            type="button"
            className="ai-mentor-cat-tab"
            style={{ fontSize: 12, padding: '4px 10px' }}
            onClick={() => setInterest(tag)}
            disabled={isLoading}
          >
            {tag}
          </button>
        ))}
      </div>
      {error && <p className="auth-error" style={{ marginTop: 8 }}>{error}</p>}
    </div>
  );
}
